<template>
  <app-layout title="Projects">
    <template #header>
      <div class="flex h-9">
        <h2
          class="flex-1 font-semibold text-xl leading-tight flex items-center"
        >
          จัดการ Cookie Banner
        </h2>
        <div>
          <jet-button
            :class="{
              'opacity-25':
                ownBusiness.projects.length >= ownBusiness.package.num_domains,
            }"
            :disabled="
              ownBusiness.projects.length >= ownBusiness.package.num_domains
            "
            @click="openCreateProjectModal"
            class="
              cursor-pointer
              inline-flex
              items-center
              px-4
              py-2
              bg-gray-800
              border border-transparent
              rounded-md
              font-semibold
              text-xs text-white
              uppercase
              tracking-widest
              hover:bg-gray-700
              active:bg-gray-900
              focus:outline-none
              focus:border-gray-900
              focus:ring
              focus:ring-gray-300
              disabled:opacity-25
              transition
            "
          >
            <span class="material-icons mr-2 md-18"> add </span>
            เพิ่มโดเมน</jet-button
          >
        </div>
      </div>
    </template>

    <div class="py-12">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div v-for="business in businesses" :key="`b-${business.id}`"
          class="p-6 sm:px-8 bg-white overflow-hidden shadow-xl sm:rounded-lg mb-6"
        >
          <div class="relative overflow-x-auto">
            <div class="text-sm font-bold mb-4">ชื่อธุรกิจ<span class="text-blue-600 ml-4">{{ business.name }}</span><span class="font-normal" v-if="business.id == ownBusiness.id"> (ธุรกิจหลัก)</span></div>
            <div class="mb-4">
              โควต้าจำนวนโดเมนตาม Package
              <span class="text-yellow-700 font-bold">{{
                business.package.name
              }}</span>
              ({{ business.projects.length }}/{{
                business.package.num_domains
              }})
            </div>
            <table class="w-full text-sm text-left text-gray-500">
              <thead
                class="
                  text-xs text-yr-primary-ii-500
                  uppercase
                  bg-yr-primary-iii-500
                "
              >
                <tr>
                  <th scope="col" class="px-6 py-3">โดเมนของฉัน</th>
                  <th scope="col" class="px-6 py-3">จำนวน Page Views</th>
                  <th scope="col" class="px-6 py-3">
                    <span class="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="business.projects.length == 0">
                  <td
                    colspan="3"
                    class="
                      px-6
                      py-4
                      font-medium
                      text-gray-900
                      border-b
                      bg-white
                      text-center
                    "
                  >
                    ยังไม่มีโดเมน
                  </td>
                </tr>
                <tr
                  v-for="project in business.projects"
                  :key="project.code"
                  class="bg-white border-b hover:bg-gray-50"
                >
                  <th
                    scope="row"
                    class="
                      px-6
                      py-4
                      font-medium
                      text-gray-900
                      whitespace-nowrap
                    "
                  >
                    <Link
                      :href="route('projects.consents.index', project)"
                      class="text-yr-secondary-500 hover:text-yr-primary-ii-500"
                      >{{ project.domain_name }}</Link
                    >
                  </th>
                  <td class="px-6 py-4">{{ project.page_views }}</td>
                  <td class="px-6 py-4 text-right">
                    <span
                      @click="openDeleteProjectModal(project)"
                      class="
                        cursor-pointer
                        text-red-400
                        hover:text-red-600
                        material-icons
                        md-18
                      "
                    >
                      delete_outline
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            v-if="business.id == ownBusiness.id && ownBusiness.projects.length == 0"
            class="flex flex-col mt-10"
          >
            <img
              class="mx-auto w-40"
              src="/img/cookie-add.png"
              alt="add domain"
            />
            <div class="text-center my-4">
              เพิ่มโดเมนเพื่อเริ่มต้นใช้งาน CookiePop
            </div>
            <div class="flex">
              <jet-button
                @click="openCreateProjectModal"
                class="
                  mx-auto
                  cursor-pointer
                  inline-flex
                  items-center
                  px-4
                  py-2
                  bg-gray-800
                  border border-transparent
                  rounded-md
                  font-semibold
                  text-white
                  uppercase
                  tracking-widest
                  hover:bg-gray-700
                  active:bg-gray-900
                  focus:outline-none
                  focus:border-gray-900
                  focus:ring
                  focus:ring-gray-300
                  disabled:opacity-25
                  transition
                "
              >
                <span class="material-icons mr-2 md-24"> add </span>
                เพิ่มโดเมน</jet-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <CreateProjectModal
      :openModal="createProjectModal"
      @close-modal="closeCreateProjectModal"
    />
    <DeleteProjectModal
      :project="selectedProject"
      :openModal="deleteProjectModal"
      @close-modal="closeDeleteProjectModal"
    />
    <!-- <GetScriptModal
      v-if="ownBusiness.length"
      :openModal="getScriptModal"
      :projectCode="ownBusiness.projects[0].code"
      @close-modal="closeGetScriptModal"
      @op-script-modal="openGetScriptModal"
    /> -->
  </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetButton from "@/Jetstream/Button.vue";
import { Link } from "@inertiajs/inertia-vue3";
import CreateProjectModal from "@/Pages/Projects/Partials/CreateProjectModal";
import DeleteProjectModal from "@/Pages/Projects/Partials/DeleteProjectModal";
// import GetScriptModal from "@/Pages/Consents/Partials/GetScriptModal";

export default defineComponent({
  props: ["ownBusiness", "businesses"],

  components: {
    AppLayout,
    Link,
    JetButton,
    CreateProjectModal,
    DeleteProjectModal,
    // GetScriptModal,
  },

  data() {
    return {
      selectedProject: null,
      createProjectModal: false,
      deleteProjectModal: false,
    //   GetScriptModal: false,
    };
  },

  methods: {
    openCreateProjectModal() {
      this.createProjectModal = true;
    },
    closeCreateProjectModal() {
      this.createProjectModal = false;
    },
    openDeleteProjectModal(project) {
      this.selectedProject = project;
      this.deleteProjectModal = true;
    },
    closeDeleteProjectModal() {
      this.selectedProject = null;
      this.deleteProjectModal = false;
    },
    // openGetScriptModal() {
    //   this.getScriptModal = true;
    // },
    // closeGetScriptModal() {
    //   this.getScriptModal = false;
    // },
  },
});
</script>
